import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import registerServiceWorker from './registerServiceWorker';
import { HashRouter } from 'react-router-dom';
import { Route, Switch } from 'react-router';
import store, { history } from './store';

import 'bootstrap';
import 'normalize.css/normalize.css';
import 'toastr/build/toastr.min.css';

import 'simple-line-icons/css/simple-line-icons.css';
import 'font-awesome/css/font-awesome.min.css';
import './assets/lib/whirl/whirl.css';
import 'animate.css/animate.min.css';

import 'moment/locale/tr';
import './assets/styles/arkea/arkea.css';

//Import polyfill for Array.prototype.includes() - IE11
import 'core-js/fn/array/includes';

import MainStateProvider from './MainStateProvider';
import EmployeePanel from './screens/EmployeePanel/';
import LoginPanel from './screens/LoginPanel/';

ReactDOM.render(
    <Provider store={store}>
        <MainStateProvider>
            <ConnectedRouter history={history}>
                <HashRouter>
                    <Switch>
                        <Route exact path="/" component={EmployeePanel} />
                        <Route path="/login" component={LoginPanel} />
                        <Route path="/" component={EmployeePanel} />
                    </Switch>
                </HashRouter>
            </ConnectedRouter>
        </MainStateProvider>
    </Provider>,
    document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js